module.exports = __webpack_public_path__ + "static/media/1-3-3.0ba28843.png";